export default "/assets/images/mila-room-showcase-03.9d96de71f3808f34.jpg";